import { getSuiNSAddress } from './getSuiNSAddress.js';
export async function resolveSuiAddress(name) {
    return await getSuiNSAddress(name);
}
//# sourceMappingURL=resolveSuiAddress.js.map